import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { iif, Observable, of, Subject } from 'rxjs';
import { delay, mergeMap, takeUntil } from 'rxjs/operators';
import TournamentBase from '../../tournament-base';
import { TournamentService } from '../../tournament.service';

@Component({
    selector: 'app-tournament-enroll',
    templateUrl: './enroll.component.html',
    styleUrls: ['./enroll.component.scss'],
})
export class TournamentEnrollComponent extends TournamentBase implements OnInit {
    departmentType: string = this.getDepartmentType();
    tournamentId: string = this.route.snapshot.paramMap.get('tournamentId');
    categoryId: string = this.route.snapshot.paramMap.get('categoryId');
    partner: any;
    icons = {
        search: faSearch,
    };

    confirmations: Array<any> = [];
    category: any;

    destroy$: Subject<any> = new Subject();

    loading: boolean;
    searching: boolean = false;
    result$ = [];

    canEnroll: boolean = false;

    alert = {
        show: false,
        status: 'success',
        message: '',
    };

    constructor(protected route: ActivatedRoute) {
        super();
    }
    ngOnInit() {
        // //console.log(this.tournamentId, this.categoryId);
        this.loading = true;
        this.tournamentService.getTournamentByID(this.tournamentId, this.departmentType).subscribe((response) => {
            this.category = response.registers.category.find((cat) => cat.id_categoria === this.categoryId);
            this.loading = false;
            if (this.category.tipo_categoria === '1') {
                this.getConfirmation();
            }

            //console.log(this.category);
        });
    }

    private getConfirmation() {
        this.loading = true;
        this.alert.show = false;
        this.tournamentService
            .confirmCategoryEnrollment(this.tournamentId, this.categoryId, this.partner?.id_site)
            .subscribe((response) => {
                this.loading = false;
                if (response.registers.detail) {
                    const keys = Object.keys(response.registers.detail);
                    this.confirmations = [];
                    keys.forEach((key) => {
                        let obj = {
                            ...response.registers.detail[key],
                            id_site: key,
                        };
                        this.confirmations.push(obj);
                    });
                }
                this.canEnroll = response.status_code === 0;

                if (response.status_code === 2) {
                    this.alert.show = true;
                    this.alert.status = 'danger';
                    this.alert.message = response.description;
                }
            });
    }

    search(value) {
        if (value.length < 3) return (this.result$ = []);

        this.searching = true;

        this.tournamentService.searchPartner(value).subscribe(
            (response) => {
                this.result$ = response.registers;
                this.searching = false;
            },
            () => {
                this.searching = false;
            }
        );
        /* .pipe(takeUntil(this.destroy$)).subscribe((response) => {

        }) */
    }

    addPartner(partner) {
        this.partner = partner;
        const lastSpot = this.confirmations.length > 1 ? this.confirmations.length - 1 : this.confirmations.length;
        // this.confirmations[lastSpot] = partner;
        setTimeout(() => {
            this.getConfirmation();
        }, 300);
    }

    enrollTournament() {
        this.loading = true;
        this.tournamentService
            .enroll(this.tournamentId, this.categoryId, this.partner?.id_site)
            .subscribe(async (response) => {
                this.loading = false;
                const keys = Object.keys(response.registers.registers.detail);
                keys.forEach((key) => {
                    const objIndex = this.confirmations.findIndex((c) => c.id_site === key);
                    const obj = response.registers.registers.detail[key];
                    this.confirmations[objIndex].status_code = obj.status_code;
                    this.confirmations[objIndex].message = obj.message;
                });

                if (response.status_code === 0) {
                    this.alert.show = true;
                    this.alert.message = response.description;
                    await this.delay();
                    this.location.historyGo(-2);
                }
            });
    }

    delay(ms = 1000) {
        return of(1).pipe(delay(ms)).toPromise();
    }

    back() {
        this.location.historyGo(-2);
    }

    getKey(filter) {
        // Retorno ex: Objeto 1: [ranking_model], Objeto2: [rating_date];
        const [key] = Object.keys(filter);
        return key;
    }

    ngOnDestroy() {
        this.destroy$.next();
    }
}
